import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, InlineNotice, toast } from '@wit-support/ui';
import { useZodFormContext } from '@wit-support/ui-forms';
import { TriangleAlert } from 'lucide-react';
import { fieldName } from '../registry/to-zod.js';
import { genderChoice } from '../registry/structured-widgets.js';
export const GENDERS_KEY = 'adset.genders';
export const ADVANTAGE_KEY = 'adset.advantageAudience';
const AGE_KEY = 'adset.age';
/** Предупреждение у пола при Advantage+ (v4 §4.2, §11.1) — тот же смысл, что `gender-with-advantage` auto-ads. */
export const GENDER_ADVANTAGE_TEXT = 'При Advantage+ аудитории пол — только подсказка для Meta: реклама может показываться и другому полу.';
/** Пол не «Все», а Advantage+ аудитория включена — нужно предупреждение. */
export function genderNeedsWarning(values) {
    return genderChoice(values[GENDERS_KEY]) !== '0' && values[ADVANTAGE_KEY] === true;
}
/** Текст тоста «быстрого исправления» (v4 §11.0): что ещё поменялось вместе с выключением. */
export function advantageOffToastText(values) {
    const age = values[AGE_KEY];
    const range = typeof age?.min === 'number' && typeof age?.max === 'number' ? `${age.min}–${age.max}` : null;
    return range
        ? `Advantage+ аудитория выключена: возраст ${range} и пол теперь строгие, расширение аудитории выкл.`
        : 'Advantage+ аудитория выключена: возраст и пол теперь строгие, расширение аудитории выкл.';
}
/**
 * «⚠ При Advantage+ аудитории пол — только подсказка…» под полем «Пол» и
 * быстрое действие «Выключить Advantage+ аудиторию» (v4 §11.1, §11.0): после
 * нажатия — тост с последствиями и [Вернуть] (до сохранения формы).
 *
 * `values` — живые контрактные значения (шаблон + форма); `prefix` — где в
 * форме лежит поле Advantage+ (`values` шаблона, `overrides` запуска); null —
 * на этом экране его менять нельзя (тогда только текст).
 */
export function GenderAdvantageNotice({ values, prefix, }) {
    const { form } = useZodFormContext();
    if (!genderNeedsWarning(values))
        return null;
    const turnOff = () => {
        if (prefix == null)
            return;
        const name = `${prefix}.${fieldName(ADVANTAGE_KEY)}`;
        form.setValue(name, false, { shouldDirty: true });
        toast.success(advantageOffToastText(values), {
            action: {
                label: 'Вернуть',
                onClick: () => form.setValue(name, true, { shouldDirty: true }),
            },
        });
    };
    return (_jsx(InlineNotice, { variant: "warning", bordered: true, icon: TriangleAlert, as: "div", "data-testid": "gender-advantage-notice", children: _jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("span", { children: GENDER_ADVANTAGE_TEXT }), prefix != null ? (_jsx(Button, { type: "button", size: "sm", variant: "secondary", className: "w-full sm:w-fit", onClick: turnOff, children: "\u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C Advantage+ \u0430\u0443\u0434\u0438\u0442\u043E\u0440\u0438\u044E" })) : (_jsx("span", { className: "text-xs", children: "\u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C Advantage+ \u043C\u043E\u0436\u043D\u043E \u0432 \u0448\u0430\u0431\u043B\u043E\u043D\u0435." }))] }) }));
}
//# sourceMappingURL=gender-advantage-notice.js.map